import { Link } from "react-router-dom";
import { SiteFooter } from "../components/SiteFooter";

export function Terms() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="px-6 py-4 flex items-center justify-between border-b border-bg-2">
        <Link to="/" className="font-semibold tracking-tight">
          MCPBuild
        </Link>
        <Link to="/" className="text-sm text-fg-1 hover:text-fg-0">
          ← Home
        </Link>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-6 py-10 space-y-6 text-fg-1 leading-relaxed">
        <h1 className="text-3xl font-semibold text-fg-0">Terms of Service</h1>
        <p className="text-xs text-fg-2">Last updated: 2026-05-21 · MCPBuild is in Beta</p>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-fg-0">Beta software</h2>
          <p className="text-sm">
            MCPBuild is an early-stage product in active development. Features
            may change, break, or disappear without notice. We recommend you
            download <code className="font-mono">.zip</code> exports of any
            widget you genuinely care about — don't rely solely on our storage.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-fg-0">Your responsibilities</h2>
          <ul className="list-disc list-inside space-y-1 text-sm">
            <li>
              <strong>The code your LLM generates is yours.</strong> Review it
              before relying on it. Don't use MCPBuild widgets to handle
              sensitive PII, secrets, or production-critical workflows.
            </li>
            <li>
              <strong>One account per person.</strong> Don't share your magic
              link.
            </li>
            <li>
              <strong>No abuse.</strong> Don't use MCPBuild to generate or host
              malware, phishing, copyright-violating content, harassment, or
              anything illegal. We may terminate accounts at our discretion.
            </li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-fg-0">What MCPBuild does</h2>
          <p className="text-sm">
            We host an MCP server that accepts React source code as a tool
            argument from your connected LLM, statically analyzes it for
            obvious unsafe patterns (<code className="font-mono">eval</code>,{" "}
            <code className="font-mono">Function</code> constructor, dynamic
            imports), bundles it with esbuild, and serves it back through the
            MCP Apps contract so your AI client renders it inline. We do not
            generate, modify, or curate the source — that's your LLM's job and
            your prompt's job.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-fg-0">No warranty</h2>
          <p className="text-sm">
            MCPBuild is provided "as is" without warranties of any kind. We are
            not liable for damages arising from your use of the service,
            including widget bugs, data loss, or downtime.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-fg-0">Contact</h2>
          <p className="text-sm">
            Operated by martzmakes LLC. Questions:{" "}
            <a
              href="mailto:matt.martz@gmail.com"
              className="text-accent underline"
            >
              matt.martz@gmail.com
            </a>
            .
          </p>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}
